import axios from "axios";
import { JTS_API_BASE_URL } from "../../../constants/Constants";

/**
 * Obtiene las líneas de precios de asignación desde la API jts-api.
 * POST a index.php con body { query_param: "assignment-price-lines" } y
 * credentials: omit para evitar CORS "No Allow Credentials" con Allow-Origin: *.
 * @returns {Promise<Array>} Array de líneas o [] en caso de error
 */
export const getAssignmentPriceLines = async () => {
  const url = `${JTS_API_BASE_URL}/index.php`;

  try {
    const response = await axios.post(
      url,
      { query_param: "assignment-price-lines" },
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: false,
      }
    );

    let payload = response.data;
    if (typeof payload === "string") {
      try {
        payload = JSON.parse(payload);
      } catch (e) {
        console.warn("getAssignmentPriceLines: respuesta no es JSON", e);
        return [];
      }
    }
    payload = payload || {};

    if (payload.status !== "ok") {
      console.warn(
        "getAssignmentPriceLines: status no ok",
        payload.status,
        payload.message
      );
      return [];
    }

    let data = payload.data;
    if (Array.isArray(data)) {
      return data;
    }
    if (data && typeof data === "object" && !Array.isArray(data)) {
      return Object.values(data);
    }

    console.warn("getAssignmentPriceLines: data no es array ni objeto", payload);
    return [];
  } catch (error) {
    console.error("Error al obtener assignment-price-lines:", error);
    return [];
  }
};

